import React, {
  createContext,
  useState,
  useContext,
  useEffect,
  useMemo
} from 'react';
import PropTypes from 'prop-types';
import keycloak, { initKeycloak, logout as keycloakLogout } from 'keycloak';
import { useLocalStorage } from './useLocalStorage'; // Assuming you have this custom hook
import CustomSpinner from 'components/common/CustomSpinner';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useLocalStorage('user', null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    initKeycloak().then(authenticated => {
      setIsAuthenticated(authenticated);
      if (authenticated) {
        setUser({ token: keycloak.token });
      }
      setIsLoading(false);
    });
  }, []);

  const login = () => {
    keycloak.login();
  };

  // const logout = () => {
  //   // console.log('logout');
  //   keycloak.logout({ redirectUri: window.location.origin });
  //   // keycloakLogout();
  //   setUser(null);
  //   setIsAuthenticated(false);
  //   localStorage.clear();
  // };

  const logout = () => {
    const logoutOptions = {
      redirectUri: window.location.origin,
      idToken: keycloak.idToken
    };

    // Construct the full logout URL with parameters
    const logoutUrl = keycloak.createLogoutUrl(logoutOptions);

    // Clear any local storage items
    // localStorage.removeItem('token');
    localStorage.clear();

    // Redirect to the constructed logout URL
    window.location.href = logoutUrl;
  };

  const value = useMemo(
    () => ({
      user,
      isAuthenticated,
      isLoading,
      login,
      logout
    }),
    [user, isAuthenticated, isLoading]
  );

  if (isLoading) {
    return (
      <div>
        <CustomSpinner />
      </div>
    );
  }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

AuthProvider.propTypes = { children: PropTypes.node };

export const useAuth = () => {
  return useContext(AuthContext);
};
